export enum BillableOperationKeys {
  BILLABLE_OPERATION_ID = "billableOperationId",
  DESCRIPTION = "description",
  COST = "cost",
  SOFTWARE_ID = "softwareId",
}

export interface BillableOperation {
  [BillableOperationKeys.BILLABLE_OPERATION_ID]: string;
  [BillableOperationKeys.DESCRIPTION]: string;
  [BillableOperationKeys.COST]: number;
  [BillableOperationKeys.SOFTWARE_ID]: string;
}
